const getUserFEAbilities = async () => {
  let abilities = [{ action: 'read', subject: 'VueAuth' }];
  return abilities;
};

export { getUserFEAbilities };
